import EmojiInput from './emoji-input'
import decodeEmoji from './decodeEmoji'
export default {
  install(Vue) {
    Vue.component('emoji-input', EmojiInput)
    Vue.prototype.$decodeEmoji = decodeEmoji
  }
}



// WEBPACK FOOTER //
// ./src/components/emoji-input/index.js